.courselinkform {
  font-family: inherit;
  font-size: inherit;
  width: 30rem;
}

.courselinkform__input-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.courselinkform__footer {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 1rem;
}

.courselinkform__results-wrapper {
  position: relative;
}

.courselinkform__results-header {
  align-items: center;
  display: flex;
  font-size: var(--font-size-text-base);
  gap: 0.5rem;
  padding: 0.5rem;
  text-align: left;
  width: 100%;
}

.courselinkform__results {
  border: 1px solid var(--color-grey-300);
  border-radius: 0.25rem;
  max-height: 10rem;
  overflow-y: auto;
}

.courselinkform__result-message {
  align-items: center;
  color: var(--color-grey-600);
  display: flex;
  font-size: var(--font-size-text-non-essential);
  height: 2rem;
  justify-content: flex-start;
  padding: 0 0.5rem;
}

.courselinkform__result-item {
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: var(--font-size-text-base);
  gap: 0.5rem;
  min-height: 2.5rem;
  padding: 0.5rem;
  text-align: left;
  width: 100%;
}

.courselinkform__results-header span,
.courselinkform__result-item span {
  line-height: 1.4;
  width: calc(100% - 9rem);
}

.courselinkform__results-header span:first-child,
.courselinkform__result-item span:first-child {
  width: 9rem;
}

.courselinkform__result-item:focus-visible {
  background-color: var(--color-grey-300);
  outline: none;
}

.courselinkform__result-item:hover,
.courselinkform__result-item:focus-visible {
  background-color: var(--color-grey-300);
}

.courselinkform__result-item:not(:last-child) {
  border-bottom: 1px solid var(--color-grey-300);
}
